export default __webpack_public_path__ + "static/media/Custom-HUD-Radar (3 Layers, 3D).b6561a5a.jpg";